type StopCountProps = {
  stopNumber: number;
  className?: string;
};

export const StopCount = ({
  stopNumber,
  className,
}: StopCountProps): React.ReactElement => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg">
    <circle id="svgCircle" fill="#000" cx="16" cy="16" r="10" />
    <text
      id="svgText"
      name="stopNumber"
      x="16"
      y="20"
      style={{
        fontSize: "10pt",
        fontFamily: "arial",
        fontWeight: "bold",
        textAnchor: "middle",
        fill: "#FFF",
      }}
    >
      {stopNumber}
    </text>
  </svg>
);
